import { useNavigate } from "react-router-dom";
import "./boxes.css";
import treinamento from "../../../assets/icons/box-main/icon-treinamento.png";
import validade from "../../../assets/icons/box-main/icon-validade.png";
import cadastro from "../../../assets/icons/box-main/icon-cadastro.png";
import pendencias from "../../../assets/icons/box-main/icon-pendencia-not.png";
import livro from "../../../assets/icons/box-main/livro.png";
import relatorio from "../../../assets/icons/box-main/relatorio.png";
import inclusao from "../../../assets/icons/box-main/inclusao.png";

const Boxes = ({ alertStatus, loading, primeiroNome, saudacao }) => {
  const navigate = useNavigate();

  function cadastrarFuncionario() {
    navigate("/cadastro");
  }

  function paginaControlar() {
    navigate("/controle");
  }

  function paginaTreinamento() {
    navigate("/treinamento");
  }

  function paginaMatriz() {
    navigate("/matriz");
  }

  function paginaInclusao() {
    navigate("/inclusao");
  }

  function paginaRelatorios() {
    navigate("/relatorios");
  }

  function verPendencias() {
    navigate("/pendencia");
  }

  const getAlertClass = () => {
    switch (alertStatus) {
      case "expired":
        return "icon-pendencias-expired";
      case "danger":
        return "icon-pendencias-danger";
      case "warning":
        return "icon-pendencias-warning";
      default:
        return "";
    }
  };

  return (
    <div className="container-box-all">
      <div className="contain-box-main">
        <div onClick={cadastrarFuncionario} className="box-main">
          <h1>CADASTRO DE TREINAMENTO</h1>
          <img src={cadastro} alt="icon-treinamento" />
        </div>

        <div onClick={paginaControlar} className="box-main">
          <h1>CONTROLE DE VALIDADE</h1>
          <img src={validade} alt="icon-cadastro" />
        </div>

        <div onClick={paginaTreinamento} className="box-main">
          <h1>TREINAMENTOS</h1>
          <img src={treinamento} alt="icon-validade" />
        </div>

        <div onClick={paginaMatriz} className="box-main">
          <h1>MATRIZ GERAL</h1>
          <img src={livro} alt="icon-validade" />
        </div>

        <div onClick={paginaInclusao} className="box-main">
          <h1>ADMINISTRAÇÃO GERAL</h1>
          <img src={inclusao} alt="icon-inclusao" />
        </div>

        <div onClick={paginaRelatorios} className="box-main">
          <h1>RELATÓRIOS</h1>
          <img src={relatorio} alt="icon-relatorios" />
        </div>
      </div>

      <div className="container-box-lateral">
        <div className="welcome-user">
          <p>{saudacao},</p>
          <strong>{primeiroNome}</strong>
        </div>

        <img
          style={{ cursor: "pointer" }}
          onClick={verPendencias}
          src={pendencias}
          alt="icon-pendencias"
          className={getAlertClass()}
        />
      </div>
    </div>
  );
};

export default Boxes;
